/* eslint-disable arrow-body-style */
import { ItemsAggregateMemory, SentencesAggregateMemory } from 'es6/models/domain-aggregate-memory';

/**
 * This class contains aggregates of items and sentences.
 */
export default class Grouping {
  constructor(attrs = {}) {
    _.defaults(this, attrs, {
      goalIds: null,
      grouping: {
        completed: null,
        cueLanguageCode: null,
        focused: null,
        uncompleted: null,
        unfocused: null,
      },
      items: null,
      sentences: null,
    });

    if (this.items && !(this.items instanceof ItemsAggregateMemory)) {
      this.items = new ItemsAggregateMemory(this.items);
    }

    if (this.sentences && !(this.sentences instanceof SentencesAggregateMemory)) {
      this.sentences = new SentencesAggregateMemory(this.sentences);
    }

    this._goalSet = new Set();

    if (this.goalIds) {
      for (const goalId of this.goalIds) {
        this._goalSet.add(goalId);
      }
    }
  }

  hasGoal(goalId) {
    return this._goalSet.has(goalId);
  }

  /**
   * Extracts list of groupings with with the specified cueLanguage
   *
   * @param {Grouping[]} groupings
   * @param {String} cueLanguageCode
   * @returns {Boolean}
   */
  static groupingsContainLanguage(groupings, cueLanguageCode) {
    return groupings.reduce((prev, grouping) => {
      return grouping.grouping.cueLanguageCode === cueLanguageCode || prev;
    }, false);
  }
}
